import { 
    SET_HEADER_BUTTONS
 } from "../constants/headerButtonsConstants";

const initialState = {
    loading: false,
    success: false,
    error: ''
};

function headerButtonsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_HEADER_BUTTONS:
            
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'headerButtonsData':action.data,
            });
     
        default:
            return state;
    }
}

export default headerButtonsReducer;

